import Blue from "~/dfwjobs/core";
import gMapsInit from "../utils/_gMaps";

new Blue({
	name: 'Event Details',
	selector: ".event-details:not(.event-details--virtual)",
	setup(container) {
    const mapElement = container.querySelector(".event-details__map");

		const markerIcon = container.getAttribute("data-icon-path");
		const address = container.getAttribute("data-address");
		const apiKey = "AIzaSyDDwGvRHioSq-wyFpUG2xFsuUjbm3uiEPA";

    async function init(apiKey) {
      let google = await gMapsInit(apiKey);
      let geocoder = new google.maps.Geocoder();

			const createAddress = (address) => {
				return new Promise((resolve) => {
					geocoder.geocode(
						{ address: address },
						(result, status) => {
							if (status !== "OK" || !result[0]) {
								resolve(false);
							}
							resolve(result[0]);
						}
					);
				});
			}

			const location = await createAddress(address);

      let mapOptions = {
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        clickableIcons: false,
        gestureHandling: "cooperative",
        disableDefaultUI: true,
				zoomControl: true,
        zoom: 9,
        center: {
					lat: location.geometry.location.lat(),
					lng: location.geometry.location.lng()
				},
      };

      const map = new google.maps.Map(
        mapElement,
        mapOptions
      );
			new google.maps.Marker({
				position: {
					lat: location.geometry.location.lat(),
					lng: location.geometry.location.lng()
				},
				map,
				icon: markerIcon
			});
    }
		init(apiKey);
	}
});